<template>
  <div id="codepop">
    <div class="img-code-p">
      <img src="@/assets/img/adcode.png" alt="" />
    </div>
  </div>
</template>
<script>
export default {
  name: "CodePop",
  data() {
    return {};
  },
  methods: {},
};
</script>
<style scoped>
.img-code-p {
  position: fixed;
  right: 30px;
  bottom: 10vh;
  z-index: 999999999;
  width: 20rem;
  height: 20rem;
}
.img-code-p img {
  width: 20rem;
  height: 20rem;
  border-radius: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/CodePop.vue